<script>
import ProductVariantAttributesMixin from '../mixins/product-variant-attributes';
import PriceMixin from '../../cart/mixins/price';
import CartForm from '../../cart/CartForm.vue';

export default {
  name: 'CompareListTableCartVariantCell',
  mixins: [PriceMixin, ProductVariantAttributesMixin],
  components: { CartForm },
  props: ['variant'],
};
</script>

<template>
  <tr>
    <td class="p-1">
      {{ getOptionValue('Conditionnement') }}
    </td>
    <td class="p-1 border-l border-gray-diagomics whitespace-nowrap">
      <div class="relative flex flex-col items-center group">
        {{ variant.sku.length > 7 ? variant.sku.substring(0, 5).concat('...') : variant.sku }}
        <div class="absolute bottom-0 flex-col items-center hidden mb-6 group-hover:flex">
          <span
            class="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-black shadow-lg"
          >
            {{ variant.sku }}
          </span>
          <div class="w-3 h-3 -mt-2 rotate-45 bg-black"></div>
        </div>
      </div>
    </td>
    <td class="border-l border-gray-diagomics pl-1 h-10 flex items-center">
      <CartForm :variant="variant" />
    </td>
  </tr>
</template>
